import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import ActivityTopBar from '../../components/ActivityTopBar/ActivityTopBar';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { theme } = useTheme();
  const [language, setLanguage] = useState('ar');

  const content = {
    ar: {
      title: 'سياسة الخصوصية',
      lastUpdated: 'آخر تحديث: فبراير 2026',
      sections: [
        {
          title: '1. المعلومات التي نجمعها',
          content: [
            'عند التسجيل في Amposter، نطلب منك اختيار اسم مستخدم يظهر للجميع.',
            'لا نطلب منك استخدام اسمك الحقيقي - يمكنك اختيار أي اسم تفضله.',
            'سيكون لديك معرف حساب فريد (ID) يكون مرئياً للمستخدمين الآخرين.',
            'لا نقوم بجمع أو تخزين معلومات شخصية حساسة من حسابك في Google أو أي خدمة تسجيل دخول أخرى.'
          ]
        },
        {
          title: '2. البيانات التي يتم إنشاؤها أثناء الاستخدام',
          content: [
            'عند استخدامك للتطبيق، يتم إنشاء بيانات إضافية تتعلق بنشاطك:',
            '• عدد العملات الافتراضية (Coins)',
            '• عدد النقاط (Points)',
            '• رسائل "صارحني"',
            '• المنشورات والتعليقات',
            '• تقدم قراءة القرآن',
            '• الإشعارات',
            '• الهاشتاقات المستخدمة',
            'هذه البيانات يتم تخزينها لتحسين تجربتك داخل التطبيق وهي مرتبطة بحسابك فقط.'
          ]
        },
        {
          title: '3. كيف نستخدم معلوماتك',
          content: [
            'نستخدم المعلومات المجمعة لـ:',
            '• تقديم وتحسين خدماتنا',
            '• تخصيص تجربتك داخل التطبيق',
            '• التواصل معك حول التحديثات والإشعارات',
            '• ضمان أمن وسلامة المنصة',
            '• الامتثال لقوانيننا وشروط الاستخدام'
          ]
        },
        {
          title: '4. مشاركة المعلومات',
          content: [
            'نحن لا نبيع أو نؤجر أو نشارك معلوماتك الشخصية مع أطراف ثالثة.',
            'المعلومات المرئية (اسم المستخدم ومعرف الحساب) تكون متاحة للمستخدمين الآخرين كجزء من التفاعل الاجتماعي.',
            'قد نكشف عن معلومات إذا كان ذلك مطلوباً بموجب القانون أو لحماية حقوقنا.'
          ]
        },
        {
          title: '5. أمن البيانات',
          content: [
            'نتخذ تدابير أمنية معقولة لحماية بياناتك من الوصول غير المصرح به أو الاستخدام غير السليم.',
            'مع ذلك، لا يمكن ضمان أمن البيانات بنسبة 100٪ عبر الإنترنت.',
            'أنت مسؤول عن الحفاظ على سرية حسابك وكلمة المرور الخاصة بك.'
          ]
        },
        {
          title: '6. حذف الحساب',
          content: [
            'يمكنك حذف حسابك في أي وقت من خلال صفحة الإعدادات.',
            'عند حذف حسابك، سيتم إزالة جميع بياناتك بشكل دائم:',
            '• معلومات الحساب',
            '• المنشورات والتعليقات',
            '• النقاط والعملات',
            '• تقدم القرآن',
            '• جميع البيانات المرتبطة بحسابك',
            'لاحظ أن هذا الإجراء نهائي ولا يمكن التراجع عنه.'
          ]
        },
        {
          title: '7. حقوق المستخدم',
          content: [
            'لديك الحق في:',
            '• الوصول إلى بياناتك الشخصية',
            '• تحديث أو تصحيح معلوماتك',
            '• حذف حسابك وبياناتك',
            '• الاعتراض على معالجة بياناتك',
            '• سحب موافقتك في أي وقت'
          ]
        },
        {
          title: '8. التغييرات على سياسة الخصوصية',
          content: [
            'قد نقوم بتحديث سياسة الخصوصية من وقت لآخر.',
            'سيتم إخطارك بأي تغييرات جوهرية من خلال إشعار داخل التطبيق.',
            'استمرارك في استخدام التطبيق بعد التغييرات يعني موافقتك على السياسة المحدثة.'
          ]
        },
        {
          title: '9. اتصل بنا',
          content: [
            'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يمكنك التواصل معنا عبر:',
            'البريد الإلكتروني: support@amposter.com',
            'أو من خلال صفحة "اتصل بنا" داخل التطبيق.'
          ]
        }
      ]
    },
    en: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated: February 2026',
      sections: [
        {
          title: '1. Information We Collect',
          content: [
            'When registering on Amposter, we ask you to choose a username that is visible to everyone.',
            'We do not require you to use your real name - you can choose any name you prefer.',
            'You will have a unique account ID that is visible to other users.',
            'We do not collect or store sensitive personal information from your Google account or any other login service.'
          ]
        },
        {
          title: '2. Data Generated During Use',
          content: [
            'When using the app, additional data related to your activity is generated:',
            '• Number of virtual coins',
            '• Number of points',
            '• "Saraha" messages',
            '• Posts and comments',
            '• Quran reading progress',
            '• Notifications',
            '• Used hashtags',
            'This data is stored to enhance your experience within the app and is linked only to your account.'
          ]
        },
        {
          title: '3. How We Use Your Information',
          content: [
            'We use the collected information to:',
            '• Provide and improve our services',
            '• Personalize your experience within the app',
            '• Communicate with you about updates and notifications',
            '• Ensure platform security and safety',
            '• Comply with our rules and terms of use'
          ]
        },
        {
          title: '4. Information Sharing',
          content: [
            'We do not sell, rent, or share your personal information with third parties.',
            'Visible information (username and account ID) is available to other users as part of social interaction.',
            'We may disclose information if required by law or to protect our rights.'
          ]
        },
        {
          title: '5. Data Security',
          content: [
            'We take reasonable security measures to protect your data from unauthorized access or misuse.',
            'However, 100% data security cannot be guaranteed over the internet.',
            'You are responsible for maintaining the confidentiality of your account and password.'
          ]
        },
        {
          title: '6. Account Deletion',
          content: [
            'You can delete your account at any time through the Settings page.',
            'When deleting your account, all your data will be permanently removed:',
            '• Account information',
            '• Posts and comments',
            '• Points and coins',
            '• Quran progress',
            '• All data associated with your account',
            'Note that this action is final and cannot be undone.'
          ]
        },
        {
          title: '7. User Rights',
          content: [
            'You have the right to:',
            '• Access your personal data',
            '• Update or correct your information',
            '• Delete your account and data',
            '• Object to data processing',
            '• Withdraw your consent at any time'
          ]
        },
        {
          title: '8. Changes to Privacy Policy',
          content: [
            'We may update the privacy policy from time to time.',
            'You will be notified of any material changes through an in-app notification.',
            'Your continued use of the app after changes means your acceptance of the updated policy.'
          ]
        },
        {
          title: '9. Contact Us',
          content: [
            'If you have any questions about this privacy policy, you can contact us via:',
            'Email: support@amposter.com',
            'Or through the "Contact Us" page within the app.'
          ]
        }
      ]
    }
  };

  const currentContent = content[language];

  return (
    <div className={`privacy-page ${theme === 'dark' ? 'theme-dark-space' : 'theme-light-space'}`}>
      <ActivityTopBar 
        title={currentContent.title} 
        className={theme === 'dark' ? 'theme-dark-item' : 'theme-light-item'} 
      />

      <div className="privacy-content">
        <div className="language-toggle">
          <button 
            className={`lang-btn ${language === 'ar' ? 'active' : ''} ${theme === 'dark' ? 'theme-dark-item' : ''}`}
            onClick={() => setLanguage('ar')}
          >
            العربية
          </button>
          <button 
            className={`lang-btn ${language === 'en' ? 'active' : ''} ${theme === 'dark' ? 'theme-dark-item' : ''}`}
            onClick={() => setLanguage('en')}
          >
            English
          </button>
        </div>

        <div className={`privacy-card ${theme === 'dark' ? 'theme-dark-item' : ''}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
          <div className="header-section">
            <h2>{currentContent.title}</h2>
            <p className="last-updated">{currentContent.lastUpdated}</p>
          </div>

          <div className="sections-list">
            {currentContent.sections.map((section, index) => (
              <div key={index} className="section-item">
                <h3>{section.title}</h3>
                <div className="section-content">
                  {section.content.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
